__turbopack_context__.v({
  "arrow": "Card-module__tGkz1q__arrow",
  "card": "Card-module__tGkz1q__card",
  "cardWrapper": "Card-module__tGkz1q__cardWrapper",
  "imageWrapper": "Card-module__tGkz1q__imageWrapper",
  "text": "Card-module__tGkz1q__text",
  "textWrapper": "Card-module__tGkz1q__textWrapper",
});
